/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceActualVehicleStateModelsVehicleFuelTank
 */
export interface ServiceActualVehicleStateModelsVehicleFuelTank {
    /**
     * 
     * @type {number}
     * @memberof ServiceActualVehicleStateModelsVehicleFuelTank
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof ServiceActualVehicleStateModelsVehicleFuelTank
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof ServiceActualVehicleStateModelsVehicleFuelTank
     */
    rawValue: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceActualVehicleStateModelsVehicleFuelTank
     */
    level?: number;
}

export function ServiceActualVehicleStateModelsVehicleFuelTankFromJSON(json: any): ServiceActualVehicleStateModelsVehicleFuelTank {
    return ServiceActualVehicleStateModelsVehicleFuelTankFromJSONTyped(json, false);
}

export function ServiceActualVehicleStateModelsVehicleFuelTankFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceActualVehicleStateModelsVehicleFuelTank {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'time': (new Date(json['time'])),
        'rawValue': json['raw_value'],
        'level': !exists(json, 'level') ? undefined : json['level'],
    };
}

export function ServiceActualVehicleStateModelsVehicleFuelTankToJSON(value?: ServiceActualVehicleStateModelsVehicleFuelTank | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'time': (value.time.toISOString()),
        'raw_value': value.rawValue,
        'level': value.level,
    };
}


